import {useState} from "react";

import {DropdownAction, DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {PrivateLocationWithGlobalStatus} from "@/lib/types/monitoring.ts";
import {EditPrivateLocationModal} from "@/pages/monitoring/privatelocations/edit/EditPrivateLocationModal.tsx";
import {PrivateLocationActionDeleteDialog} from "@/pages/monitoring/privatelocations/list/tableComponents/actions/PrivateLocationActionDeleteDialog.tsx";

type PrivateLocationProps = {
  location: PrivateLocationWithGlobalStatus;
};

export const PrivateLocationActions = ({location}: PrivateLocationProps) => {
  const [showRename, setShowRename] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  return (
    <>
      <QuickActionsBar
        id={`private-location-action-${location.id}`}
        actions={[
          <DropdownAction
            id={`private-location-dd-${location.id}`}
            items={[
              <DropdownActionItem text="Delete" onClick={() => setShowDelete(true)} />,
              <DropdownActionItem text="Rename" onClick={() => setShowRename(true)} />,
            ]}
          />,
        ]}
      />
      <PrivateLocationActionDeleteDialog location={location} show={showDelete} setShow={setShowDelete} />
      <EditPrivateLocationModal location={location} show={showRename} hide={() => setShowRename(false)} />
    </>
  );
};
